import sortBy from 'lodash/sortBy'

import { AccountGroup } from '@modules-deprecated/app/accounts/types'

export const sortAccountGroups = (groups: AccountGroup[]) => {
  return sortBy(groups, ['priority', 'accountNo'])
}
